module.exports = __webpack_public_path__ + "static/img/corporateMember.67789f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/corporateMember.png
// module id = wT/a
// module chunks = 1